import { STATUS_TO_PILL, statusLabel } from "../lib/format";

export default function StatusPill({ status }) {
  const tone = STATUS_TO_PILL[status] || "dim";
  return (
    <span className={`pill ${tone}`} data-testid={`status-${status}`}>
      {statusLabel(status)}
    </span>
  );
}
